import { render, staticRenderFns } from "./DuplicateIds.vue?vue&type=template&id=681387f6&scoped=true&"
import script from "./DuplicateIds.vue?vue&type=script&lang=js&"
export * from "./DuplicateIds.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateIds.vue?vue&type=style&index=0&id=681387f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681387f6",
  null
  
)

export default component.exports